import { render, staticRenderFns } from "./products-list.vue?vue&type=template&id=1f29cbc2&"
import script from "./products-list.vue?vue&type=script&lang=js&"
export * from "./products-list.vue?vue&type=script&lang=js&"
import style0 from "./products-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f29cbc2')) {
      api.createRecord('1f29cbc2', component.options)
    } else {
      api.reload('1f29cbc2', component.options)
    }
    module.hot.accept("./products-list.vue?vue&type=template&id=1f29cbc2&", function () {
      api.rerender('1f29cbc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/catalog/products-list.vue"
export default component.exports